// Bar-chart glyph beside the Advanced MaxDiff HB heading.
const QuestionIcon = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="33px"
    height="33px"
    viewBox="0 0 33.02 32.63"
    enableBackground="new 0 0 33 33"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#4d4d4d"
        d="M26.83,32.63H6.19A6.2,6.2,0,0,1,0,26.43V11.25A6.2,6.2,0,0,1,6.19,5.06h2A6.16,6.16,0,0,1,14.27,0h4.48A6.2,6.2,0,0,1,25,6.19v5.06h1.88A6.19,6.19,0,0,1,33,17.44v9A6.2,6.2,0,0,1,26.83,32.63ZM6.19,6.91a4.35,4.35,0,0,0-4.34,4.34V26.43a4.34,4.34,0,0,0,4.34,4.34H26.83a4.34,4.34,0,0,0,4.34-4.34v-9a4.34,4.34,0,0,0-4.34-4.34H23.09V6.19a4.34,4.34,0,0,0-4.34-4.34H14.27A4.32,4.32,0,0,0,10,6l0,.89Z"
      ></path>
      <rect fill="#29abe2" x="6.19" y="11.25" width="4.49" height="15.18"></rect>
      <rect fill="#ff9500" x="14.27" y="6.19" width="4.49" height="20.24"></rect>
      <rect fill="#ed1c24" x="22.34" y="17.44" width="4.49" height="9"></rect>
    </g>
  </svg>
)

export default QuestionIcon
